import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import AuthShell from "../../components/layout/AuthShell";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import api from "../../lib/api";
import { formatApiError } from "../../context/AuthContext";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset Password"
      subtitle="We'll send you a link to reset your password."
      footer={<p><Link to="/login" className="text-gold hover:underline" data-testid="link-back-login">Back to sign in</Link></p>}
    >
      {sent ? (
        <div className="rounded-xl cf-glass p-6 text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto h-10 w-10 text-gold" />
          <p className="mt-4 text-white">If an account exists for <span className="text-gold">{email}</span>, a reset link has been sent.</p>
          <p className="mt-2 text-xs text-muted-foreground">Phase 1: the reset link is printed in the backend server console.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-white/80">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" data-testid="forgot-email-input" className="bg-navy border-white/15 text-white h-11 focus-visible:ring-gold" />
          </div>
          <Button type="submit" disabled={loading} className="w-full cf-gold-btn font-semibold h-11" data-testid="forgot-submit-btn">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
